import React from 'react';
import { DataGrid } from '../../../../libs/x-data-grid/DataGrid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ColumnMenuComponent from './Column-menu.component';
import VisibleMenuComponent from './Visible-menu.component';
import FooterComponent from './Footer.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import { IProps as IColumnProps } from './Column-menu.component';

const Component: React.FC<IProps> = ({
    page,
    lang,
    loading,
    isTelemetryVisible,
    serverError,
    limit,
    telemetryList,
    sortModel,
    columnVisibilityModel,
    visibilitySettingsState,
    visibilitySettingsEl,
    visibilitySettingsRef,
    columns,
    rows,
    onClose,
    onPageChange,
    onDownloadClick,
    onRowClick,
    onSortModelChange,
    onUnsort,
    onAscSort,
    onDescSort,
    onHideCol,
    onToggleCol,
    onVisibilitySettingsStateChange,
    onVisibilitySettingsStateClose,
    onShowAllCol,
    onHideAllCol,
    onLimitChange,
}: IProps) => {
    const getWord = useDictionary();
    const ErrorOverlay = () => {
        return (
            <Typography className="telemetry__no-rows-overlay">
                {getWord('error')}
            </Typography>
        );
    };
    const NoRowsOverlay = () => {
        return (
            <Typography className="telemetry__no-rows-overlay">
                {getWord('noData')}
            </Typography>
        );
    };
    const ColumnMenu = (
        inputProps: Pick<
            IColumnProps,
            'currentColumn' | 'disableHide' | 'hideMenu'
        >,
    ) => {
        const props = {
            ...inputProps,
            onUnsort,
            onAscSort,
            onDescSort,
            onHideCol,
        };
        return (
            <>
                <ColumnMenuComponent {...props} />
            </>
        );
    };
    const Footer = () => {
        const classes = {
            tooltipPopper: 'telemetry__tooltip-popper',
            tooltip: 'telemetry__tooltip',
            btnDownload: 'telemetry__btn_download',
            ico: 'telemetry__ico',
            btnVisibility: 'telemetry__btn_visibility',
            btnBar: 'telemetry__btn-bar',
            tablePagination: 'telemetry__table-pagination',
            tablePaginationInput: 'telemetry__table-pagination-input',
            tablePaginationInputItem: 'telemetry__table-pagination-input-item',
            tablePaginationInputTitle:
                'telemetry__table-pagination-input-title',
            tablePaginationInputWrap: 'telemetry__table-pagination-input-wrap',
            tablePaginationActions: 'telemetry__table-pagination-actions',
            tablePaginationRowsLabel: 'telemetry__table-pagination-rows-label',
            tablePaginationSelectLabel:
                'telemetry__table-pagination-select-label',
        };
        const props = {
            classes,
            lang,
            page,
            limit,
            loading,
            dataLength: telemetryList.length,
            onDownloadClick,
            onVisibilitySettingsStateChange,
            onPageChange,
            onLimitChange,
        };
        return (
            <>
                <FooterComponent {...props} />
            </>
        );
    };

    if (isTelemetryVisible) {
        return (
            <Box className="telemetry" component="section">
                <IconButton className="telemetry__btn_close" onClick={onClose}>
                    <CloseIcon className="telemetry__ico_close" />
                </IconButton>
                <Box className="telemetry__wrap">
                    <DataGrid
                        classes={{
                            root: 'telemetry__table',
                            virtualScrollerRenderZone: 'telemetry__table-body',
                            cell: 'telemetry__table-cell',
                            columnHeaderTitleContainer:
                                'telemetry__table-col-header',
                            columnHeaderTitleContainerContent:
                                'telemetry__table-col-header-content',
                            columnHeaderTitle:
                                'telemetry__table-col-header-title',
                            row: 'telemetry__table-row',
                            virtualScroller:
                                'telemetry__table-virtual-scroller',
                        }}
                        columns={columns}
                        rows={loading ? [] : rows}
                        pageSize={limit}
                        rowsPerPageOptions={[limit]}
                        headerHeight={28}
                        rowHeight={28}
                        loading={loading}
                        page={page}
                        onRowClick={onRowClick}
                        ref={visibilitySettingsRef}
                        components={{
                            ErrorOverlay,
                            NoResultsOverlay: NoRowsOverlay,
                            NoRowsOverlay,
                            ColumnMenu,
                            Footer,
                        }}
                        error={serverError ? true : null}
                        //disableColumnMenu
                        sortModel={sortModel}
                        columnVisibilityModel={columnVisibilityModel}
                        onSortModelChange={onSortModelChange}
                    />
                    <VisibleMenuComponent
                        open={visibilitySettingsState}
                        anchorEl={visibilitySettingsEl}
                        columnVisibilityModel={columnVisibilityModel}
                        onClose={onVisibilitySettingsStateClose}
                        onToggleCol={onToggleCol}
                        onShowAllCol={onShowAllCol}
                        onHideAllCol={onHideAllCol}
                    />
                </Box>
            </Box>
        );
    } else return <></>;
};

const DeviceTelemetryComponent = React.memo(Component);

export default DeviceTelemetryComponent;
